import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "button", "idle", "running", "done", "forceToggle", "backfillDays"]
  static values = { triggerUrl: String, statusUrl: String, forceBackfillUrl: String }

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  toggleForce() {
    this.backfillDaysTarget.disabled = !this.forceToggleTarget.checked
  }

  trigger() {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const force = this.forceToggleTarget.checked
    const days = this.backfillDaysTarget.value

    this.dialogTarget.close()
    this.#setRunning()

    const url = force ? this.forceBackfillUrlValue : this.triggerUrlValue
    const headers = { "X-CSRF-Token": csrf, "Accept": "application/json" }
    const opts = { method: "POST", headers }

    if (force && days) {
      headers["Content-Type"] = "application/json"
      opts.body = JSON.stringify({ backfill_days: parseInt(days) })
    }

    fetch(url, opts)
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          window.toast(data.error || "Failed to trigger scrape", { kind: "error" })
          this.#setIdle()
          return
        }
        this.#poll(data.triggered_at)
      })
      .catch(() => this.#setIdle())
  }

  #poll(triggeredAt) {
    let attempts = 0
    const url = new URL(this.statusUrlValue, window.location.origin)
    url.searchParams.set("since", triggeredAt)

    const interval = setInterval(() => {
      if (++attempts > 60) {
        clearInterval(interval)
        this.#setIdle()
        return
      }

      fetch(url, { headers: { "Accept": "application/json" } })
        .then(r => r.json())
        .then(({ pending }) => {
          if (pending === 0) {
            clearInterval(interval)
            this.#setDone()
            setTimeout(() => this.#setIdle(), 1500)
          }
        })
    }, 2000)
  }

  #setRunning() {
    this.buttonTarget.disabled = true
    this.idleTarget.classList.add("hidden")
    this.runningTarget.classList.remove("hidden")
    this.doneTarget.classList.add("hidden")
  }

  #setDone() {
    this.buttonTarget.disabled = false
    this.runningTarget.classList.add("hidden")
    this.doneTarget.classList.remove("hidden")
  }

  #setIdle() {
    this.buttonTarget.disabled = false
    this.idleTarget.classList.remove("hidden")
    this.runningTarget.classList.add("hidden")
    this.doneTarget.classList.add("hidden")
  }
}
